import { useContext } from 'react'

import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiDeleteFetcher } from '@/common/api/fetcher'
import {
  DeleteAnalysisTargetResponse,
  DeleteAnalysisTargetVars,
  GetAnalysisTargetResponse,
  GetAnalysisTargetVars,
  ListAnalysisTargetsResponse,
  ListAnalysisTargetsVars,
  MediaAnalysisTargetApiPath
} from '@/common/api/params/mediaAnalysisTarget'
import { useShowDeletedToast } from '@/common/app/toast'
import { MediaAnalysisTarget } from '@/common/model/media/mediaAnalysisTarget'

import { DeleteDialogContext } from '@/components/container/modal/dialog/delete/DeleteDialogProvider'

export const useAnalysisTargetGetApi = ({
  siteId,
  targetId
}: {
  siteId: number
  targetId: number
}) => {
  return useSWR<GetAnalysisTargetResponse, Response, [string, GetAnalysisTargetVars]>([
    MediaAnalysisTargetApiPath.GET_ANALYSIS_TARGET,
    { site_id: siteId, target_id: targetId }
  ])
}

export const useAnalysisTargetListApi = (vars: ListAnalysisTargetsVars) => {
  return useSWR<ListAnalysisTargetsResponse, Response, [string, ListAnalysisTargetsVars]>([
    MediaAnalysisTargetApiPath.LIST_ANALYSIS_TARGETS,
    vars
  ])
}

export const useAnalysisTargetDeleteApi = (target: MediaAnalysisTarget, onSuccess: () => void) => {
  const showDeleted = useShowDeletedToast()
  const { showModal, hide } = useContext(DeleteDialogContext)

  const { trigger } = useCallMutation<DeleteAnalysisTargetResponse, DeleteAnalysisTargetVars>(
    MediaAnalysisTargetApiPath.DELETE_ANALYSIS_TARGET,
    {
      onSuccess: () => {
        showDeleted(target.name)
        hide()
        onSuccess()
      }
    },
    apiDeleteFetcher
  )

  const onClickDelete = () => {
    showModal({
      name: target.name,
      onClickDelete: () => trigger({ site_id: target.site_id, target_id: target.id }).then()
    })
  }
  return { onClickDelete }
}
